<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="1" :tab="$t('tab.receivingList')" style="margin-top: -14px">
        <receiving-close-table ref="receivingCloseTable" :orderStatusData="orderStatusData" @dblclick="dblclick" @success="success"/>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('tab.orderDetails')" forceRender style="margin-top: -14px">
        <receiving-close-detail ref="receivingCloseDetail" :orderStatusData="orderStatusData"/>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <a-button type="primary" @click="getData">{{ $t('button.query') }}</a-button>
        <a-button type="primary" @click="reset">{{ $t('button.reset') }}</a-button>
        <a-button type="primary" @click="close">{{ $t('button.close') }}</a-button>
      </a-space>
    </a-tabs>
  </a-layout>
</template>

<script>
  import {findEnum} from '@/api/Api'
  import ReceivingCloseTable from '@/views/inbound/receiving_close/ReceivingCloseTable.vue'
  import ReceivingCloseDetail from '@/views/inbound/receiving_close/ReceivingCloseDetail.vue'

  export default {
    name: 'ReceivingClose',
    components: {
      ReceivingCloseDetail,
      ReceivingCloseTable
    },
    data() {
      return {
        activeKey: '1',
        orderStatusData: [],
        countingTypeData: [],
        approveLoading: false,
        rejectLoading: false,
        approveDisabled: false,
        rejectDisabled: false
      }
    },
    mounted() {
      findEnum('OrderStatus').then(res => {
        if (res.success) {
          this.orderStatusData = res.result
        }
      })
      findEnum('CountingType').then(res => {
        if (res.success) {
          this.countingTypeData = res.result
        }
      })
    },
    methods: {
      dblclick(record) {
        this.activeKey = '2'
        this.$refs.receivingCloseDetail.getData(record)
      },
      success() {
        this.$refs.receivingCloseTable.getData()
        this.$refs.receivingCloseDetail.clear()
      },
      getData() {
        this.$refs.receivingCloseTable.getData()
      },
      reset() {
        this.$refs.receivingCloseTable.reset()
      },
      close() {
        this.$refs.receivingCloseTable.close()
      }
    }
  }
</script>